import axios from 'axios';


export const SyncFullMexGlobalFilterOperations = () => {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `mex-global-filter/sync-full`,  {
      headers,
    });
  };
